<template>
  <div
    v-if="show"
    style="position: absolute; top: 0; left: 0; width: 100%; z-index: 9999999"
  >
    <b-alert v-model="show" dismissible variant="danger"
      ><span>有重复内容标题</span></b-alert
    >
  </div>
</template>
<script>
import manager from "@/server/api/contentManager";
export default {
  data() {
    return {
      show: false,
      title: "",
      timer: "",
    };
  },
  methods: {
    checkTitle(title, isCreate) {
      console.log("检查重复", title, isCreate);
      if (title) {
        this.title = title;
        this.getContentList(isCreate);
      } else {
        this.show = false;
      }
    },
    //跳转内容管家
    toContentManage() {
      let routeData = this.$router.resolve({
        name: "contentManager",
        query: { repeatTitle: this.title },
      });
      window.open(routeData.href, "_blank");
    },
    getContentList(isCreate) {
      let params = {
        page: 1,
        pageSize: 1,
        title: this.title,
        volcano: 0, //不展示与火山内容重复
      };
      manager.list(params).then((res) => {
        if (typeof res == "object" && res.code === 0 && res.data) {
          let num = isCreate ? 0 : 1;
          if (
            res.data.total > num ||
            (!isCreate &&
              res.data.total == 1 &&
              res.data.items[0].id != this.$route.query.id)
          ) {
            this.show = true;
            if (this.timer) {
              clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
              (this.show = false), clearTimeout(this.timer);
            }, 30000);
          } else {
            if (this.timer) {
              clearTimeout(this.timer);
            }
            this.show = false;
          }
        }
      });
    },
  },
  watch: {},
};
</script>
<style scoped></style>
